module.exports = __webpack_public_path__ + "static/img/commemorative-sign-novalloy.e71c25f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/what-we-do/commemorative-sign-novalloy.jpg
// module id = 149
// module chunks = 0